import React from "react";
import { IPostAudioProps } from "./PostAudio.types";
import { PostAudio } from "./PostAudio";

export const LazyLoadedPostAudio = (props: IPostAudioProps) => {
  if (!props.showAudio || !props.audios?.length) return null;

  return <PostAudio {...props} />;
};

export default LazyLoadedPostAudio;
